import React, { useState } from 'react';

interface PlayerInputProps {
  onAddPlayer: (name: string) => void;
  players: string[];
}

const PlayerInput: React.FC<PlayerInputProps> = ({ onAddPlayer, players }) => {
  const [playerName, setPlayerName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (playerName.trim()) {
      onAddPlayer(playerName.trim());
      setPlayerName('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="bg-white rounded-none shadow-lg p-8 mb-7 border-none">
      <h2 className="text-2xl font-bold mb-4">Add Players</h2>
      <form onSubmit={handleSubmit} className="mb-4">
        <div className="flex gap-4">
          <input
            type="text"
            className="flex-1 w-full px-4 py-3 border border-gray-300 rounded-none text-lg bg-gray-50 text-gray-900 transition-colors duration-200 outline-none shadow-sm focus:border-purple-600 focus:shadow-md focus:bg-white"
            placeholder="Enter player name"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            onKeyPress={handleKeyPress}
            maxLength={20}
          />
          <button type="submit" className="btn">
            Add Player
          </button>
        </div>
      </form>
      
      {players.length > 0 && (
        <div>
          <h3 className="text-lg font-bold mb-2">Current Players ({players.length})</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {players.map((player, index) => (
              <div key={index} className="p-4 border border-gray-200 rounded-md bg-green-100 text-green-800">
                <span className="font-bold">{player}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {players.length >= 2 && (
        <div className="mt-4 p-4 bg-yellow-100 text-yellow-800 rounded-md">
          <p className="text-center">
            Ready to start! You can begin the game with {players.length} players.
          </p>
        </div>
      )}
    </div>
  );
};

export default PlayerInput; 